import { Action } from '@ngrx/store';

export const LOAD_FEATURE_FLAGS = '[Feature Flags] Load Flags';
export const FEATURE_FLAGS_SUCCESS = '[Feature Flags] Success';
export const FEATURE_FLAGS_ERROR = '[Feature Flags] Error';

export class LoadFeatureFlags implements Action {
  readonly type = LOAD_FEATURE_FLAGS;
}

export class FeatureFlagsSuccess implements Action {
  readonly type = FEATURE_FLAGS_SUCCESS;
  constructor(public payload: any) {}
}

export class FeatureFlagsError implements Action {
  readonly type = FEATURE_FLAGS_ERROR;
  constructor(public payload: string) {}
}

export type FeatureFlagActions =
  | LoadFeatureFlags
  | FeatureFlagsSuccess
  | FeatureFlagsError;
